module.exports = __webpack_public_path__ + "media/images/map/map-img-0fbf866a2fd1f3a4127fa369e518a69f.png";